<template>
    <div id="main">
        <div class="page">
            <alert-container :messages="msgs" />
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('altera-usuario') }}
                            <a class="pl-1" v-if="hide.hideInfo" @click="infoIsHidden()">
                                <b-icon
                                    v-if="!hide.infoIsHidden"
                                    icon="eye-off-outline"
                                    type="is-danger"
                                />
                                <b-icon
                                    v-if="hide.infoIsHidden"
                                    icon="eye-outline"
                                    type="is-success"
                                />
                            </a>
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('settings') }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{ $t('altera-usuario') }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            v-if="permissao.update"
                            class="save-btn"
                            type="button"
                            @click="updateUsuario()"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
            </div>
            <div class="altera-usuario mt-3">
                <div class="center">
                    <div class="form">
                        <div class="nome-input">
                            <v-input
                                v-model="user.nome"
                                :hideInfo="hide.hideInfo"
                                :infoIsHidden="hide.infoIsHidden"
                                :id="'nome'"
                                :placeholder="'usuario-nome-placeholder'"
                                :maxlength="50"
                                :title="'usuario-nome'"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!user.nome"
                                ref="nomeInput"
                            />
                        </div>
                        <div class="login-input">
                            <v-input
                                v-model="user.login"
                                :hideInfo="hide.hideInfo"
                                :infoIsHidden="hide.infoIsHidden"
                                :id="'login'"
                                :placeholder="'login-placeholder'"
                                :maxlength="50"
                                :title="'login'"
                                :msg="invalidLoginMsg"
                                :invalid="invalidLogin"
                                :onBlurFunction="validateLogin"
                                ref="loginInput"
                            />
                        </div>
                        <div>
                            <b-checkbox v-model="showInputResetPassword">
                                {{ $t('criar-nova-senha') }}
                                <b-icon
                                    icon="information"
                                    size="is-small"
                                    v-tippy
                                    :title="$t('msg-senha-fraca')"
                                />
                            </b-checkbox>
                        </div>
                        <div v-if="showInputResetPassword" class="password-input">
                            <v-input
                                v-model="user.novaSenha"
                                :uppercase="false"
                                id="new-pass"
                                :placeholder="'ph-nova-senha'"
                                :maxlength="50"
                                :title="'nova-senha'"
                                :msg="invalidMsg"
                                :onBlurFunction="validateNewPass"
                                :invalid="invalidNewPass"
                                ref="novaSenhaInput"
                                :type="'password'"
                            />

                            <v-input
                                v-model="user.confirmeNovaSenha"
                                :uppercase="false"
                                id="confirm-new-pass"
                                :placeholder="'ph-confirme-nova-senha'"
                                :maxlength="50"
                                :title="'confirme-nova-senha'"
                                :msg="invalidMsg"
                                :onBlurFunction="validateNewPass"
                                :invalid="invalidNewPass"
                                ref="confirmeNovaSenhaInput"
                                :type="'password'"
                            />
                        </div>
                    </div>
                </div>
                <div class="exclusao-dados">
                    <div>
                        <b-checkbox v-model="showInputExclusao">
                            {{ $t('solicitar-exclusao') }}
                            <b-icon
                                icon="information"
                                size="is-small"
                                v-tippy
                                :title="$t('msg-info-exclusao')"
                            />
                        </b-checkbox>
                    </div>
                    <div v-if="showInputExclusao" class="exclusao-input">
                        <div class="texto-exclusao" v-html="$t('politica-de-exclusao')" />
                        <div class="email-input">
                            <v-input
                                v-model="emailRemetente"
                                :uppercase="false"
                                :maxlength="50"
                                :title="'email-remetente-exclusao'"
                                :placeholder="'ph-email-remetente-exclusao'"
                                :msg="invalidEmailMsg"
                                :invalid="invalidEmail"
                                :onBlurFunction="validateEmailInner"
                            />
                        </div>
                        <v-textarea
                            v-model="emailConteudo"
                            :placeholder="'ph-corpo-email-exclusao'"
                            :maxlength="2000"
                            :title="'corpo-email-exclusao'"
                            :rows="8"
                        />
                        <button class="save-btn" type="button" @click="sendEmail()">
                            {{ $t('enviar-email') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UsuarioService from '@/services/UsuarioService';
import UsuarioValidation from '@/services/validations/UsuarioValidation';
import Message from '@/models/Message';
import HideInfo from '@/components/shared/HideInfo';
import { mapState } from 'vuex';

export default {
    components: {
        UsuarioService,
        HideInfo,
    },
    data() {
        return {
            isSaving: false,
            service: null,
            title: '',
            cleanHide: true,
            msgs: [],
            tokenData: '',
            showInputResetPassword: false,
            showInputExclusao: false,
            invalidMsg: '',
            invalidNewPass: false,
            invalidLogin: false,
            invalidUsername: false,
            invalidEmail: false,
            invalidLoginMsg: 'msg-campo-obrigatorio',
            invalidEmailMsg: 'msg-campo-obrigatorio',
            emailConteudo: '',
            emailRemetente: '',
            user: {
                nome: '',
                login: '',
                senha: '',
                oldlogin: '',
                novaSenha: '',
                confirmeNovaSenha: '',
            },
            credentials: {},
            isLogin: true,
            service: null,
            msgs: [],
            isLogging: false,
        };
    },
    computed: {
        ...mapState(['hide']),
    },
    created() {
        this.service = new UsuarioService(this.$http, this.$router);
        this.validation = new UsuarioValidation(this.msgs);

        this.permissao = this.hasPermissionAccess('admin', 'account', 'altera-usuario');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'altera-usuario' },
            });
        } else {
            this.loggedUser = JSON.parse(window.atob(this.$cookies.get('token').split('.')[1])).sub;
            this.carregarDados(this.loggedUser);
        }
    },
    mounted() {
        this.$refs.nomeInput.$refs.typed.focus();
    },
    methods: {
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', { infoIsHidden: !this.hide.infoIsHidden });
        },
        validateNewPass(msg) {
            if (this.user.novaSenha != this.user.confirmeNovaSenha) {
                this.invalidMsg = 'msg-senhas-diferentes';
                this.invalidNewPass = true;
            } else if (!this.user.novaSenha || !this.user.confirmeNovaSenha) {
                this.invalidMsg = 'msg-campo-obrigatorio';
                this.invalidNewPass = true;
            } else {
                this.invalidNewPass = false;
            }

            //Lógica para validação retornada do back end
            if (msg == 'msg-senha-fraca') {
                this.invalidMsg = msg;
                this.invalidNewPass = true;
            }
        },
        validateLogin() {
            if (this.user.login && !this.validateEmailInner(this.user.login)) {
                this.invalidLogin = true;
                this.invalidLoginMsg = 'msg-campo-invalido';
            } else {
                this.invalidLogin = false;
            }
        },
        carregarDados(login) {
            this.service
                .findByLogin(login)
                .then(this.mapItems)
                .then((body) => {
                    body.oldlogin = this.loggedUser;
                    this.user = body;
                });
        },
        mapItems(body) {
            let list = body.content;
            return list;
        },
        updateUsuario() {
            this.validateNewPass();
            if (this.validation.validate(this.user, this.$refs, this.showInputResetPassword)) {
                this.$root.confirm({
                    message: this.$t('msg-update-usuario'),
                    onConfirm: this.salvar,
                });
            }
        },
        salvar() {
            this.user.senha = this.user.novaSenha;
            this.isSaving = true;
            this.service
                .save(this.user)
                .then((body) => {
                    if (body.content) {
                        // Mudar para alerta padrão, quando o mesmo for criado
                        let msg = 'msg-dados-alterados';
                        this.user = body.content;
                        this.msgs.push(new Message('success', msg, true));
                        setTimeout(() => {
                            this.service.doLogout();
                        }, 1500);
                        // this.redirect(time);
                        // this.login();
                    } else {
                        if (this.$t(body.message)) {
                            if ((body.message = 'msg-senha-fraca')) {
                                this.validateNewPass(body.message);
                            }
                            this.msgs.push(new Message('alert', body.message, true));
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    }
                    this.isSaving = false;
                })
                .catch((e) => {
                    this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                    this.isSaving = false;
                });
        },
        // Valida se o e-mail é valido
        validateEmailInner() {
            if (this.emailRemetente && this.validateEmail(this.emailRemetente)) {
                this.invalidEmail = false;
            } else {
                this.invalidEmail = true;
                this.invalidEmailMsg = 'msg-campo-invalido';
            }
        },
        //Realiza o envio do e-mail
        sendEmail() {
            if (!this.invalidEmail && this.emailRemetente) {
                let mail = {
                    assunto: 'Exclusão real de dados - LGPD',
                    conteudoHtml:
                        'E-mail enviado por: ' +
                        this.emailRemetente +
                        '<br> <br>' +
                        this.emailConteudo,
                    destino: 'lgpd@sovis.com.br',
                    emailOrigem: this.emailRemetente,
                };
                this.isLoadingModal = true;
                this.service
                    .enviarEmail(mail)
                    .then((r) => {
                        this.$root.showMessage('success', 'msg-email-sucess');
                        this.onCancelFields();
                    })
                    .catch((e) => {
                        console.error('Erro ao enviar o e-mail.');
                    })
                    .finally((_) => {
                        this.isLoadingModal = false;
                    });
            } else {
                this.validateEmailInner();
                this.$root.showMessage('alert', 'msg-email-invalido');
            }
        },
        onCancelFields() {
            this.emailRemetente = '';
            this.emailConteudo = '';
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
}
.page {
    .altera-usuario {
        position: relative;
        width: 100%;
        margin-bottom: 20px;
        height: 100%;
        padding-top: 0;
    }
}

.altera-usuario .center {
    width: 100%;
    left: 0;
    transform: translateX(0);
    margin: 0;
    box-sizing: border-box;
    position: initial;
    padding-bottom: 20px;
}

.page .form {
    // display: block;
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    border-radius: 2px;
    text-align: left;

    .nome-input {
        width: 49.5%;
    }
    .login-input {
        width: 49.5%;
        input {
            text-transform: none !important;
        }
    }
    .password-input {
        width: 100%;
    }
}

.nav.nav-tabs {
    margin-bottom: 40px;
    margin-left: -40px;
    padding-left: 60px;
    margin-right: 0px;
    padding-right: 20px;
}

.texto-exclusao {
    text-align: justify;
    font-size: 12px;
}
.email-input {
    width: 49.5%;
}
</style>
